import React, { FC, memo } from "react";
import { Image } from "@chakra-ui/react";
import mAccessories from "@images/20922-Menu-accesories.webp";
import mManagementConsole from "@images/20922-Menu-Manage-Console.webp";
import mPa100 from "@images/20922-Menu-PA-100.webp";
import mPa200 from "@images/20922-Menu-PA-200.webp";
import mPowerControl from "@images/20922-Menu-PCS.webp";
import mAccessoriesJPG from "@images/20922-Menu-accesories.jpg";
import mManagementConsoleJPG from "@images/20922-Menu-Manage-Console.jpg";
import mPa100JPG from "@images/20922-Menu-PA-100.jpg";
import mPa200JPG from "@images/20922-Menu-PA-200.jpg";
import mPowerControlJPG from "@images/20922-Menu-PCS.jpg";
import { ImageListKey } from "@modules/ProductCategory/models/type";

interface IProps {
  name: ImageListKey | string;
}

export type IImageSrcList = {
  [key in ImageListKey]: {
    src: string;
    jpgSrc: string;
    alt: string;
  };
};
const imageSrcList: IImageSrcList = {
  mAccessories: {
    src: mAccessories,
    jpgSrc: mAccessoriesJPG,
    alt: "Accessories",
  },
  mManagementConsole: {
    src: mManagementConsole,
    jpgSrc: mManagementConsoleJPG,
    alt: "PA200 for Commercial Use",
  },
  mPa100: {
    src: mPa100,
    jpgSrc: mPa100JPG,
    alt: "PA100 Series for Government Use",
  },
  mPa200: {
    src: mPa200,
    jpgSrc: mPa200JPG,
    alt: "PA200 for Commercial Use",
  },
  mPowerControl: {
    src: mPowerControl,
    jpgSrc: mPowerControlJPG,
    alt: "Power Control System",
  },
};

const ImageWebpFormat: FC<IProps> = ({ name }) => {
  const img = imageSrcList[name as ImageListKey];

  if (!img) {
    return null;
  }

  return (
    <picture
      style={{
        width: "100%",
        height: "auto",
      }}
    >
      <source type="image/webp" srcSet={img.src} />
      <source srcSet={img.jpgSrc} type="image/jpeg" />
      <Image
        src={img.jpgSrc}
        alt={img.alt}
        loading="lazy"
        width="100%"
        height={"auto"}
        top="0"
        left="0"
        objectFit="cover"
        maxWidth="100%"
        maxHeight="100%"
      />
    </picture>
  );
};

export default memo(ImageWebpFormat);
